//todo move to custom bootstrapvalidator
function switchPasswordStrengthAlert(formGroup, passwordEl, alertName, message) {
    const password = passwordEl.val();

    let alerts = formGroup.getElementsByClassName('alert');

    alertName === 'invalid'
        ? formGroup.classList.add('has-error', 'has-danger')
        : formGroup.classList.remove('has-error', 'has-danger');

    let helpBlock = formGroup.getElementsByClassName('help-block')[0];
    helpBlock.innerHTML = message;

    for (var i = 0; i < alerts.length; ++i) {
        alerts[i].style.display = "none";
    }

    if (password.length) {
        for (var i = 0; i < alerts.length; ++i) {
            let element = alerts[i];

            if (element.classList !== undefined && element.classList.contains('alert-' + alertName)) {
                element.style.display = 'flex';
            }
        }
    }
}

export default switchPasswordStrengthAlert;
